<div class="custom-chatbot-ui" [@slideInOut]="isChatbotOpen ? 'open' : 'closed'">
  <!-- Welcome Screen -->
  <div *ngIf="showWelcome">
    <div class="custom-chatbot-header">
      <button (click)="toggleChatbot.emit()" class="custom-close-btn" aria-label="Close chatbot">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="custom-chatbot-welcome">
      <div class="welcome-header-section">
        <div class="custom-welcome-avatar">
          <ng-container *ngIf="botAvatar; else defaultAvatar">
            <img [src]="botAvatar" alt="AI Avatar" class="welcome-avatar-img" />
          </ng-container>
          <ng-template #defaultAvatar>
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="welcome-avatar-img" viewBox="0 0 16 16" aria-label="eXobe.AI Avatar">
              <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a24.286 24.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"/>
              <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 1 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"/>
            </svg>
          </ng-template>
        </div>
        <div class="welcome-bot-name">eXobe.AI</div>
      </div>
      <div class="welcome-message-section">
        <div class="welcome-message-bubble">
          <div class="message-avatar-small">
            <ng-container *ngIf="botAvatar; else defaultAvatarSmall">
              <img [src]="botAvatar" alt="AI Avatar" class="small-avatar-img" />
            </ng-container>
            <ng-template #defaultAvatarSmall>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a24.286 24.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"/>
                <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 1 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"/>
              </svg>
            </ng-template>
          </div>
          <div class="message-content">
            <p class="welcome-greeting" [innerHTML]="welcomeMessage"></p>
            <p class="welcome-subtext">Choose one of these popular topics or type your question below.</p>
          </div>
        </div>
      </div>
      
      <!-- Quick Action Buttons -->
      <div class="quick-actions-section">
        <div class="quick-action-buttons">
          <!-- These will be populated with content you provide -->
          <button class="quick-action-btn" *ngFor="let action of quickActions">
            <i [class]="action.icon"></i>
            <span>{{ action.label }}</span>
            <span class="badge-new" *ngIf="action.isNew">NEW</span>
          </button>
        </div>
      </div>
      
      <!-- Skill Spotlight Section -->
      <div class="skill-spotlight-section">
        <div class="spotlight-header">
          <i class="fa fa-sparkles spotlight-icon"></i>
          <span class="spotlight-title">Skill Spotlight</span>
        </div>
        <p class="spotlight-subtitle">Do you know I can help you to..</p>
        <div class="spotlight-items">
          <!-- These will be populated with content you provide -->
          <div class="spotlight-item" *ngFor="let skill of spotlightSkills">
            <span class="skill-text">{{ skill.text }}</span>
            <i class="fa fa-arrow-right skill-arrow"></i>
          </div>
        </div>
      </div>
      
      <!-- Input Area - Visible on Welcome Screen -->
      <div class="custom-chatbot-input-area">
        <button class="menu-toggle-btn" aria-label="Menu">
          <i class="fa fa-bars"></i>
        </button>
        <input
          #inputRefWelcome
          [(ngModel)]="input"
          class="custom-chatbot-input"
          type="text"
          placeholder="Type your question here..."
          (keydown)="handleInputKeyDown($event)"
          [disabled]="loading"
        />
        <button
          class="custom-send-btn"
          (click)="handleSend()"
          [disabled]="loading || !input.trim()"
          aria-label="Send message"
        >
          <i class="fa fa-paper-plane"></i>
        </button>
      </div>
      
      <!-- Footer Links - Visible on Welcome Screen -->
      <div class="chatbot-footer">
        <a href="#" class="footer-link">My Skills</a>
        <span class="footer-separator">|</span>
        <a href="#" class="footer-link">T&C</a>
        <span class="footer-separator">|</span>
        <a href="#" class="footer-link">Feedback</a>
      </div>
    </div>
  </div>

  <!-- Chat Interface -->
  <div *ngIf="!showWelcome" class="custom-chatbot-container">
    <div class="custom-chatbot-header">
      <div class="header-left">
        <div class="header-avatar">
          <ng-container *ngIf="botAvatar; else defaultHeaderAvatar">
            <img [src]="botAvatar" alt="AI Avatar" class="header-avatar-img" />
          </ng-container>
          <ng-template #defaultHeaderAvatar>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
              <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a24.286 24.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"/>
              <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 1 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"/>
            </svg>
          </ng-template>
        </div>
        <span class="custom-bot-title">eXobe.AI</span>
      </div>
      <button (click)="toggleChatbot.emit()" class="custom-close-btn" aria-label="Close chatbot">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="custom-chatbot-messages" #messageContainer>
      <div *ngFor="let msg of messages; let i = index" class="custom-message-row {{ msg.from }}">
        <div class="custom-message-bubble {{ msg.from }} {{ msg.type }} {{ msg.from === 'bot' && i === messages.length - 1 && isTyping ? 'typing' : '' }}">
          {{ msg.from === 'bot' && i === messages.length - 1 && isTyping ? msg.displayText : msg.text }}
        </div>
      </div>
      <div *ngIf="loading && !isTyping" class="custom-message-row bot">
        <div class="custom-message-bubble bot loading">
          <span></span>
        </div>
      </div>
    </div>
    <div class="custom-chatbot-input-area">
      <button class="menu-toggle-btn" aria-label="Menu">
        <i class="fa fa-bars"></i>
      </button>
      <input
        #inputRef
        [(ngModel)]="input"
        class="custom-chatbot-input"
        type="text"
        placeholder="Type your question here..."
        (keydown)="handleInputKeyDown($event)"
        [disabled]="loading"
      />
      <button
        class="custom-send-btn"
        (click)="handleSend()"
        [disabled]="loading || !input.trim()"
        aria-label="Send message"
      >
        <i class="fa fa-paper-plane"></i>
      </button>
    </div>
    <div class="chatbot-footer">
      <a href="#" class="footer-link">My Skills</a>
      <span class="footer-separator">|</span>
      <a href="#" class="footer-link">T&C</a>
      <span class="footer-separator">|</span>
      <a href="#" class="footer-link">Feedback</a>
    </div>
  </div>
</div>
